<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean
  title?: string
  indeterminate?: boolean
  badge?: number | string
  titleClass?: string
}>()
</script>

<template>
  <div class="d-flex align-center justify-space-between px-2 py-1">
    <div class="d-flex align-center">
      <v-checkbox
        :model-value="props.modelValue"
        :indeterminate="props.indeterminate"
        :ripple="false"
        class="mr-4 mt-0 ml-2 pt-0"
        color="brand-primary"
        density="compact"
        hide-details
      />

      <v-list-item-title
        class="mr-8"
        :class="props.titleClass"
      >
        {{ props.title }}
      </v-list-item-title>
    </div>

    <v-badge
      v-if="props.badge != null && props.badge !== 0"
      :content="props.badge"
      color="brand-primary"
      inline
    />
  </div>
</template>
